import { useRouter } from "next/router";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

import MDXPageEN from "@components/contact/contact_en.mdx";
import MDXPagePL from "@components/contact/contact_pl.mdx";

export async function getStaticProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
    },
  };
}

const ThemedPage = () => {
  const { locale } = useRouter();

  return <>{locale === "pl" ? <MDXPagePL /> : <MDXPageEN />}</>;
};

export default function Contact() {
  return <ThemedPage />;
}
